import { faker } from '@faker-js/faker';
import { stableCertificateId } from './certificateStandards';

export type CertificateInstituteRecord = {
  id: string;
  /** Numeric id aligned with Mirage/SCM institute list (stable per generated row). */
  apiId: number;
  label: string;
};

const CERTIFICATE_INSTITUTE_MOCK_COUNT = 99;
const CERTIFICATE_INSTITUTE_FAKER_SEED = 202_604_23;

faker.seed(CERTIFICATE_INSTITUTE_FAKER_SEED);

function generateCertificateInstituteRecords(): CertificateInstituteRecord[] {
  const usedIds = new Set<string>();
  const rows: CertificateInstituteRecord[] = [];

  for (let i = 0; i < CERTIFICATE_INSTITUTE_MOCK_COUNT; i++) {
    const label = faker.company.name();
    const id = stableCertificateId(label, i, usedIds);
    rows.push({ id, apiId: i + 1, label });
  }

  return rows;
}

export const CERTIFICATE_INSTITUTE_RECORDS = generateCertificateInstituteRecords();

export function getCertificateInstitutes(): CertificateInstituteRecord[] {
  return CERTIFICATE_INSTITUTE_RECORDS;
}
